// extracted by mini-css-extract-plugin
export default {"header":"sSY7z","label":"DZXDe","progress":"_1DOKQ","statusContainer":"_1yZLf","errorFilled":"_17J1b","successFilled":"_2Wc5R","toggle":"_2Ajri","closeBigStakeBarButton":"_1r9F7"};